<script setup lang="ts" name="DataTableResponsiveRow">
import { hasStickyColumns } from '~/features/useDataTableStickyColumn';

import BaseItem from '~/components/BaseItem.vue';

import type {
  IDataTableBaseCell,
  IDataTableResponsiveRow,
  IDataTableSettingsActions,
} from '~/types';

defineProps<{
  row: IDataTableResponsiveRow;
  areaOverflows: boolean;
  columns: IDataTableBaseCell[];
  actions?: IDataTableSettingsActions;
}>();
</script>

<template>
  <div class="col-[1/_columns-end]">
    <div class="grid w-full grid-cols-2 gap-y-4 bg-charcoal-0 p-4">
      <div v-for="cell in row.cells" :key="cell.key" class="px-4">
        <BaseItem v-bind="cell" />
      </div>
    </div>
  </div>
  <div
    v-if="actions || hasStickyColumns(columns)"
    class="cargo-booking-sticky-actions col-[sticky-start/sticky-end] border-l border-l-charcoal-2 bg-charcoal-0"
    :class="{
      'cargo-booking-sticky-shadow': areaOverflows,
    }"
  ></div>
</template>
